export const jwtRegex = /^([a-zA-Z0-9_=]+)\.([a-zA-Z0-9_=]+)\.([a-zA-Z0-9_\-=]*$)/;

// Error messages

export const INVALID_TOKEN_ERROR = 'Empty or invalid token';

// url query params keys
export const TOKEN_QUERY_KEY = 'token';
export const REFRESH_TOKEN_QUERY_KEY = 'refresh_token';
